import {Component, HostListener} from '@angular/core';
import {AppAlertService} from "../core";

@Component({
    selector: 'app-alert',
    templateUrl: './app-alert.component.html',
    styleUrls: ['./app-alert.component.scss']
})
export class AppAlertComponent {
    constructor(
        public appAlert: AppAlertService,
    ) {}

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.appAlert.windowHeight = event.target.innerHeight;
    }
}
